namespace TabAurous.Purchase {
    export namespace OpenConsignmentInService {
        export const baseUrl = 'Purchase/OpenConsignmentIn';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PartyList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Purchase/OpenConsignmentIn/List",
            PartyList = "Purchase/OpenConsignmentIn/PartyList"
        }

        [
            'List', 
            'PartyList'
        ].forEach(x => {
            (<any>OpenConsignmentInService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
